import {
  DefaultFetchError,
  FetchCreate,
  FetchGet,
  FetchGetId,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate,
  useFetchGet,
  useFetchGetId,
  useFetchUpdate,
} from "../fetch";

export interface Exercise {
  id: string;
  name: string;
  middah: {
    id: string;
    name: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface ExerciseTableRow extends Exercise {
  key: string;
}

export interface ExerciseTableData {
  data: ExerciseTableRow[];
  total: number;
}

export interface ExerciseCreateParams {
  name: string;
  middah: {
    id: string;
  };
}

export interface ExerciseUpdateParams {
  name: string;
}

export interface ExerciseGetParams
  extends PagingParams, Partial<Omit<Exercise, "id" | "middah">> {
  orderByColumn?: keyof Omit<Exercise, "id" | "middah">;
}
export const useExerciseGet = <DD = PagingDataResponse<Exercise>>(
  decorateData?: (data: PagingDataResponse<Exercise>) => DD,
): FetchGet<
  PagingDataResponse<Exercise>,
  ExerciseGetParams,
  DefaultFetchError,
  DD
> =>
  useFetchGet("exercises", {
    autoStart: false,
    startStateLoading: false,
    decorateData,
  });

export const useExerciseTableGet = () =>
  useExerciseGet<ExerciseTableData>(
    ({ data, meta }: PagingDataResponse<Exercise>): ExerciseTableData => ({
      data: data.map((item) => ({
        key: item.id,
        ...item,
      })),
      total: meta.itemCount,
    }),
  );

export const useExerciseGetById = <DD = Exercise>(
  id?: string,
  decorateData?: (data: Exercise) => DD,
): FetchGetId<Exercise, DefaultFetchError, unknown, DD> =>
  useFetchGetId("exercises", id, {
    autoStart: !!id,
    decorateData,
  });

export const useExerciseCreate = (): FetchCreate<
  ExerciseCreateParams,
  DefaultFetchError,
  ExerciseCreateParams
> => useFetchCreate("exercises");

export const useExerciseUpdate = (
  id?: string,
): FetchUpdate<ExerciseUpdateParams, DefaultFetchError, ExerciseUpdateParams> =>
  useFetchUpdate("exercises", id);
